module.exports = __webpack_public_path__ + "img/inzlUB8OjijhvHujYMBlk3gUtBKzTWNMIMt0cuwJ.b9fde307.jpg";